import React from 'react'

const Totop = () => {
  return (
    <button className='to-top-btn'>
        <i className="fa-solid fa-angle-up"></i>
    </button>
  )
}

export default Totop
